import type { ILogEntry } from '../../domain/logging/log-entry';
import { ApiBaseService } from '../api-base-service';

export class LoggingApiService extends ApiBaseService {
    constructor(context = '/delegate') {
        super(`${context}/logging`);
    }

    async writeLog(logEntry: ILogEntry) {
        return this.http.post('/log', logEntry);
    }
}
